export const supporters = [
  'Margarida Tomás',
  'Sandro Nilo',
  'André Amaral',
  'Marcos André',
  'João Jesus',
]
